var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"span":+_vm.Grid}},[(_vm.blockName)?_c(_vm.blockName,{tag:"component"}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }